import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../service/auth-service/auth-service.service';
import { SectionService } from '../../service/section-service/section-service';
import { SectionName } from '../../ui/SectionName';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  menuItems: any[] = [];
  @Input() isMaintenance: boolean | undefined;

  constructor(private authService: AuthService,
    private componentLoaderService: SectionService,
    private router: Router
  ) { }

  loadSection(sectionSelected: string) {
    this.componentLoaderService.loadSection(sectionSelected);
  }

  tooltipMessageExport(){
     return this.authService.isEMAOrganisation() ? 'This tool enables users to query and download data for specific organisation(s)' : 'This tool enables users to query and download data owned by their HQ Organisation';
  }

  tooltipMessageUpdate(){
     return this.authService.isEMAOrganisation() ? 'This tool enables users to generate a maintenance related XEVPRM for multiple AMPs for specific organisation(s)' : 'This tool enables users to generate a maintenance related XEVPRM for multiple AMPs owned by their HQ organisation';
  }


  ngOnInit(): void {

    //reason -> logout, sessionexpired
    this.authService.getLogoutCompleted().subscribe(
      (reason) => {
        this.init();
        if (reason === 'sessionexpired') {
          this.router.navigate(['/sessionexpired'], { skipLocationChange: true });
        }
      }
    );

    this.authService.organisationSwitchCompleted$.subscribe(
      () => {
        this.init();
        this.router.navigate(['/login'], { skipLocationChange: true });
      }
    );


    this.authService.getLoginCompleted().subscribe(
      loggedUser => {

        this.init();

        //Return the first allowed section with permission with priority
        const allowedSection = [...this.menuItems].sort((a, b) => {
                if (a.priority > b.priority) { 
                  return 1 
                } else { 
                  return -1 
                }
          })
          .find(item => item.permission);

        if (allowedSection) {
          this.authService.setSelectedSection(allowedSection.route);
        }

        this.loadSection(this.authService.selectedSection);
      });

  }

  init(): void {
    this.menuItems = [];
    this.menuItems.push({ priority: 3, label: 'WEB Trader', permission: this.componentLoaderService.isWebTraderAllowed(), route: SectionName.webtrader, tooltipMsg: 'Viewing and Downloading of the Files in the Inbox and Outbox Folders (WEB Trader)' });
    this.menuItems.push({ priority: 2, label: 'Create and Send Product Reports', permission: this.componentLoaderService.isAllowedProductReports(), route: SectionName.createandsendproductreports, tooltipMsg: 'Creation, Follow Up and Sending of Medicinal Product Messages' });
    this.menuItems.push({ priority: 1, label: 'Medicinal Products', permission: this.componentLoaderService.isMedicinalProductsAllowed(), route: SectionName.medicinalproducts, tooltipMsg: 'Querying, Viewing, Browsing and Downloading of Medicinal Products' });
    this.menuItems.push({ priority: 4, label: 'MedDRA', permission: this.componentLoaderService.isMeddraAllowed(), route: SectionName.meddra, tooltipMsg: 'Querying, Viewing and Browsing of MedDRA' });
    this.menuItems.push({ priority: 5, label: 'Post', permission: this.componentLoaderService.isPostAllowed(), route: SectionName.post, tooltipMsg: 'Send EVPRM messages in ZIP format' });
    this.menuItems.push({ priority: 6, label: 'Bulk Export', permission: this.componentLoaderService.isBulkExportAllowed(), route: SectionName.bulkexport, tooltipMsg: this.tooltipMessageExport() });
    this.menuItems.push({ priority: 7, label: 'Bulk Update', permission: this.componentLoaderService.isBulkUpdateAllowed(), route: SectionName.bulkupdate, tooltipMsg: this.tooltipMessageUpdate() });
  }
}
